export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-c5f8ba5c3852194ad1b0.worker.js");
}
